/** ~2MB — keeps base64 JSON bodies within typical PHP post limits */
export const MAX_IMAGE_BYTES = 2 * 1024 * 1024;

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

/** Larger documents (PDF, Office) for admin downloads */
export const MAX_DOCUMENT_BYTES = 12 * 1024 * 1024;

const DOC_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
];

export function validateImageFile(file) {
  if (!file) return 'No file selected';
  if (file.size > MAX_IMAGE_BYTES) {
    return `Image must be ${MAX_IMAGE_BYTES / 1024 / 1024} MB or smaller`;
  }
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return 'Please use JPG, PNG, GIF, or WebP';
  }
  return null;
}

export function validateDocumentFile(file) {
  if (!file) return 'No file selected';
  if (file.size > MAX_DOCUMENT_BYTES) {
    return `File must be ${MAX_DOCUMENT_BYTES / 1024 / 1024} MB or smaller`;
  }
  if (file.type && !DOC_TYPES.includes(file.type)) {
    return 'Allowed: PDF, Word, Excel, JPG, PNG';
  }
  return null;
}

/**
 * Read image as data URL after validation. Rejects with an Error message string.
 */
export function readValidatedImageAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const err = validateImageFile(file);
    if (err) {
      reject(new Error(err));
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Could not read the file'));
    reader.readAsDataURL(file);
  });
}

/** Read PDF/Office/image document as data URL for API JSON body. */
export function readValidatedDocumentAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const err = validateDocumentFile(file);
    if (err) {
      reject(new Error(err));
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Could not read the file'));
    reader.readAsDataURL(file);
  });
}
